"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveChatNotificationApiBase = void 0;
const AuthTokenHandlerBase_1 = require("../Authorization/AuthTokenHandlerBase");
const RequestInitHandler_1 = require("../RequestInitHandler");
class LiveChatNotificationApiBase extends AuthTokenHandlerBase_1.AuthTokenHandlerBase {
    constructor(logger, httpHandler, settings) {
        super(logger, httpHandler, settings);
        this.Logger = logger;
        this.HttpHandler = httpHandler;
        this.Settings = settings;
        this.AlmeBaseUri =
            `${this.Settings.AlmeApiProtocol}${this.Settings.AlmeApiHostname}${this.Settings.AlmeApiBasePath}`;
    }
    async GetNotificationAsync(notificationRequest) {
        const notificationRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiNotificationEndpoint}?sessionId=${notificationRequest.sessionId}`;
        const notificationRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'GET');
        this.AddAuthHeader(notificationRequestInit);
        const response = await this.HttpHandler.SendAsync(notificationRequestInfo, notificationRequestInit);
        if (typeof response === 'undefined') {
            return;
        }
        if (typeof response !== 'object') {
            throw new Error('Invalid Response');
        }
        return response;
    }
    async GetLiveChatNotificationAsync(notificationRequest) {
        let notificationRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiLiveChatNotificationEndpoint}?sessionId=${notificationRequest.sessionId}`;
        if (typeof notificationRequest.index === 'number' && !isNaN(notificationRequest.index) && notificationRequest.index >= 0) {
            notificationRequestInfo += `&index=${notificationRequest.index}`;
        }
        const notificationRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'GET');
        this.AddAuthHeader(notificationRequestInit);
        const response = await this.HttpHandler.SendAsync(notificationRequestInfo, notificationRequestInit);
        if (typeof response === 'undefined') {
            return;
        }
        if (typeof response !== 'object') {
            throw new Error('Invalid Response');
        }
        return response;
    }
}
exports.LiveChatNotificationApiBase = LiveChatNotificationApiBase;
//# sourceMappingURL=LiveChatNotificationApiBase.js.map